import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Button } from "primereact/button";
import { Card } from "primereact/card";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import Input from "../input/Input";
import { NextButton, PrevButton } from "./kycSidebar";
import { useTranslation } from "react-i18next";
import React, { useState, useEffect, useRef } from "react";
import ApiService from "../service/apiService";
import configureStore from "../../redux/store";
import { DynamicFieldSection } from "./personalDetails";
import { useDispatch, useSelector } from "react-redux";
import {
  pushDocumentListData,
  removeDocumentListData,
  setDocumentTypeList,
  setDocumentValue,
  updateDocumentListData,
} from "../../redux/documentSlice";
import FileUploadComponent from "../other/fileUploadComponent";
import { SaveButton } from "./declerationDetails";
import { Image } from "primereact/image";
import ApiBaseURLProps from "../other/apiBaseURL";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { useForm, Controller } from "react-hook-form";
import { Dropdown } from "primereact/dropdown";
import { classNames } from "primereact/utils";
import { adToBs, bsToAd } from "@sbmdkl/nepali-date-converter";
import NepaliDatePicker2 from "../other/nepaliDatePicker";
import EditDocumentDetails from "./editDocumentDetail";
import { useToast } from "../other/Toast";
import lookupService from "../service/lookupService";
import { getTValue } from "../other/label";
import { Dialog } from "primereact/dialog";
import InputText from "../other/InputText";
import AdBsDatePicker from "../other/adBsDatePicker";
import { confirmDialog } from "primereact/confirmdialog";
import { InputMask } from "primereact/inputmask";
import CustomImage from "../other/Image";
import { setDocIdError } from "../../redux/occupationSlice";
import { setIssuedDateError, setIssuedFromError } from "../../redux/personSlice";

export const PERSON_DETAIL_DOCUMENT = [];
export const ADDRESS_DETAIL_DOCUMENT = ["MP"];
export const USER_DETAIL_DOCUMENT = ["PH", "VDO"];
export const NON_DOCUMENT_DETAIL_DOCUMENT = [
  ...PERSON_DETAIL_DOCUMENT,
  ...ADDRESS_DETAIL_DOCUMENT,
  ...USER_DETAIL_DOCUMENT,
];

const documentMeta = {
  docId: {
    docField: "docId",
    labelEng: "Document Id",
    labelNep: "Document Id",
    placeholderEng: "Document Id",
    placeholderNep: "Document Id",
  },
  issuedDate: {
    docField: "issuedDate",
    labelEng: "Issued Date",
    labelNep: "Issued Date",
    placeholderEng: "Issued Date",
    placeholderNep: "Issued Date",
  },
  issuedDateBs: {
    docField: "issuedDateBs",
    labelEng: "Issued Date BS",
    labelNep: "Issued Date BS",
    placeholderEng: "Issued Date BS",
    placeholderNep: "Issued Date BS",
  },
  issuedFrom: {
    docField: "issuedFrom",
    labelEng: "Issued From",
    labelNep: "Issued From",
    placeholderEng: "Issued From",
    placeholderNep: "Issued From",
  },
};

const footer = () => (
  <div class=" p-field p-col-12 p-md-12">
    <div className="p-grid" style={{ flex: 3 }}>
      <div style={{ flex: 1 }}>
        <PrevButton />
      </div>
      <div style={{
        flex: 1,
      }}>
        <SaveButton />
      </div>
      <div style={{ flex: 1 }}>
        <NextButton />
      </div>
    </div>
  </div>
  // <div className="p-grid">
  //   <div className="p-col-12 p-md-5">
  //     <PrevButton />
  //   </div>
  //   <div className="p-col-12 p-md-2">
  //     <SaveButton />
  //   </div>
  //   <div className="p-col-12 p-md-3"></div>
  //   <div className="p-col-12 p-md-2">
  //     <NextButton />
  //   </div>
  // </div>
);

function DocumentDetails() {
  const { t, i18n } = useTranslation();
  const formType = useSelector((state) => state.routerData.formType);
  const documentTypeList = useSelector(
    (state) => state.documentDetails.documentTypeList
  );
  const documentList = useSelector(
    (state) => state.documentDetails.documentList
  );
  const locationType = useSelector(
    (state) => state.addressDetails.locationType
  );
  const nationality = useSelector((state) => state.personalDetails.nationality);
  const isMinor = useSelector((state) => state.personalDetails.isMinor);
  const documentForMinor = useSelector(
    (state) => state.personalDetails.documentForMinor
  );
  const isNrn = useSelector((state) => state.personalDetails.isNrn);
  // const documentDetailsError = useSelector(
  //   (state) => state.documentDetails.documentDetailsError
  // );
  const errorObj = useSelector((state) => state.documentDetails.errors);
  let documentDetailsError = "";

  if (errorObj && errorObj.documentDetailsError) {
    documentDetailsError = errorObj.documentDetailsError.message;
  }

  const dispatch = useDispatch();
  const docIdError = useSelector((state) => state.occupationDetails.errors.docIdError);
  const issuedDateError = useSelector((state) => state.personalDetails.errors.issuedDateError);
  const issuedFromError = useSelector((state) => state.personalDetails.errors.issuedFromError);

  const [fileId, setFileId] = useState();
  const [docId, setDocId] = useState();
  const [issuedFrom, setIssuedFrom] = useState();
  const [issuedFromDesc, setIssuedFromDesc] = useState();
  const [issuedDate, setIssuedDate] = useState();
  const [issuedDateBs, setIssuedDateBs] = useState();
  const [fileData, setFileData] = useState({});
  const [status, setStatus] = useState(false);
  const [rowId, setRowId] = useState();
  const [rowData, setRowData] = useState();
  const [docStatus, setDocStatus] = useState(false);
  const [fileName, setFileName] = useState(false);
  const [fileError, setFileError] = useState(false);
  const [documentTypeId, setDocumentTypeId] = useState();
  const [documentType, setDocumentType] = useState({});
  const [documentMetadata, setDocumentMetadata] = useState({});
  const [documentTypeOthers, setDocumentTypeOthers] = useState();
  const toast = useToast();
  const [loadingdt, setLoadingdt] = useState(false);

  useEffect(() => {
    if (!districtList) {
      lookupService.getDistrictList(dispatch);
    }
    reset({
      documentTypeId: documentTypeId,
      docId: docId,
      issuedDate: issuedDate,
      issuedDateBs
    });
  }, []);

  let documentDetail = {};
  function isValidDate(date) {
    var regEx = /^\d{4}-\d{2}-\d{2}$/;
    if (!date.match(regEx)) return false; // Invalid format
    var d = new Date(date);
    var dNum = d.getTime();
    if (!dNum && dNum !== 0) return false; // NaN value, Invalid date
    return d.toISOString().slice(0, 10) === date;
  }

  const getDescription = (pList, param) => {
    return ((pList && pList.find((p) => p.code === param)) || {}).descEng;
  };

  useEffect(() => {
    if (!documentTypeList.length) {
      setLoadingdt(true)

      ApiService.getDocumentTypeList().then((response) => {
        dispatch(setDocumentTypeList(response.data.data));
      }).finally(() => setLoadingdt(false));
    }
  }, []);

  useEffect(() => {
    if (documentTypeId) {
      const dType = {
        ...(documentTypeList.find((d) => d.code === documentTypeId) || {}),
      };
      if (dType && dType.documentMetadata && dType.documentMetadata.length) {
        dType.documentMetadata = dType.documentMetadata.reduce((a, v) => {
          a[v.docField] = v;
          return a;
        }, {});
      } else {
        dType.documentMetadata = documentMeta;
      }
      // console.log("docMetadata", dType.documentMetadata);
      setDocumentMetadata(dType.documentMetadata);
      setDocumentType(dType);
    } else setDocumentType({});
  }, [documentTypeId]);

  const resetDocumentForm = () => {
    setRowId("");
    setDocId("");
    setIssuedFromDesc("");
    setIssuedFrom("");
    setIssuedDate("");
    setIssuedDateBs("");
    setDocumentTypeId(null);
    setFileData({});
    reset();
    setFileError(false);
    setDocIdError(false);
    setIssuedDateError(false);
    setIssuedFromError(false);
  };

  const handleDocumentDetail = () => {
    documentDetail = {
      documentTypeId,
      documentTypeOthers,
      documentTypeCode: documentType.documentTypeCode,
      documentTypeDesc: documentType.descEng,
      documentTypeDescNp: documentType.descNep,
      docId,
      issuedFrom,
      issuedFromDesc,
      issuedDate,
      issuedDateBs,
      ...fileData,
    };
    // console.log("handleDocCheck", documentDetail);
    // Validation for document types: Citizenship (CZ) and Birth Certificate (BC) and others
    // if ((documentTypeId === "CZ" || documentTypeId === "BC" || documentTypeId === "O" || documentTypeId === "TC" || documentTypeId === "AD" || documentTypeId === "AGM" || documentTypeId === "PP" || documentTypeId === "nid") && (!docId || !/^[a-zA-Z0-9]+$/.test(docId))) {
    //   // Display an error message if validation fails
    //   dispatch(setDocIdError({ message: "Provide a valid document ID", section: documentTypeId }));
    //   return;
    // }
    // else if ((documentTypeId === "BC") && (!issuedDate)) {
    //   dispatch(setIssuedDateError({ message: "Provide Proper Issue Date", section: issuedDate }));
    //   return;
    // }

    // //recently commented on 6/12/2025
    // if ((documentTypeId === "CZ" || documentTypeId === "BC") && (!issuedDate || issuedDate.trim() === "")) {
    //   dispatch(setIssuedDateError({ message: "Provide a valid Issued Date", section: issuedDate }));
    //   return;
    // }
    // else if ((documentTypeId === "CZ" || documentTypeId === "BC") && (!issuedFrom || issuedFrom.trim() === "")) {
    //   dispatch(setIssuedFromError({ message: "Provide a valid Issued From", section: issuedFrom }));
    //   return;
    // }
    // // else if ((documentTypeId === "BC") && (!issuedFrom)) {
    // //   dispatch(setIssuedFromError({ message: "Issue From is required", section: issuedFrom }));
    // //   return;
    // // }
    // else if (
    //   documentType &&
    //   (documentType.fileInfo === "M") &&
    //   !documentDetail.fileId
    // ) {
    //   setFileError(true);
    // } 
    if (
      (documentTypeId === "CZ" || documentTypeId === "BC") && !docId
    ) {
      dispatch(setDocIdError({ message: "Document Id is required", section: documentTypeId }));
      return;
    } else if (
      (documentTypeId === "O" || documentTypeId === "TC" || documentTypeId === "AD" || documentTypeId === "AGM" || documentTypeId === "PP") &&
      (!docId || !/^[a-zA-Z0-9]+$/.test(docId))
    ) {
      dispatch(setDocIdError({ message: "Provide a valid document ID", section: documentTypeId }));
      return;
    } else if ((documentTypeId === "BC") && (!issuedDate)) {
      dispatch(setIssuedDateError({ message: "Provide Proper Issue Date", section: issuedDate }));
      return;
    }
    else if ((documentTypeId === "CZ" || documentTypeId === "BC") && (!issuedFrom)) {
      dispatch(setIssuedFromError({ message: "Issue From is required", section: documentTypeId }));
      return;
    }
    else if (
      documentType &&
      (documentType.fileInfo === "M") &&
      !documentDetail.fileId
    ) {
      setFileError(true);
    }

    else if (((documentTypeId === "BC" || documentTypeId === "CZ") && (!issuedFrom))) {
      toast.warning("Message", "Issue From is required");
      return;
    }
    else if ((documentTypeId === "BC" || documentTypeId === "CZ") && !docId) {
      toast.warning("Message", "Document Id is required");
      return;
    }
    else if ((documentTypeId === "BC" || documentTypeId === "CZ") && !issuedDate) {
      toast.warning("Message", "Issue Date is required");
      return;
    }
    else if (
      documentType &&
      (documentType.isBothSided) &&
      !documentDetail.backFileId
    ) {
      setFileError(true);
    }
    else if (rowId) {
      dispatch(
        updateDocumentListData({ documentDetail: documentDetail, id: rowId })
      );
      resetDocumentForm();
      setAddVisible(false);
    } else if (
      documentType.isMultiple ||
      !documentList.find((d) => d.documentTypeId === documentTypeId)
    ) {
      dispatch(pushDocumentListData(documentDetail));
      resetDocumentForm();
      setAddVisible(false);
    } else {
      toast.warning("Message", "Multiple" + documentType.descEng + " not allowed!")
    }
  };

  const displayConfirmModal = (param) => {
    confirmDialog({
      message: "Are you sure you want to proceed?",
      header: "Confirmation",
      icon: "pi pi-exclamation-triangle",
      accept: () => dispatch(removeDocumentListData(param)),
    });
  };

  const getFileName = (fileName) => {
    setFileName(fileName.fileName);
    setFileId(fileName.id);
  };

  const toogleDocStatus = (docStatus) => {
    setDocStatus((prevCheck) => !prevCheck);
  };

  const editDocumentDetail = (editedDocumentObj) => {
    dispatch(updateDocumentListData(editedDocumentObj));
  };

  const districtList = useSelector((state) => state.lookupDetails.districtList);

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
    setValue,
    clearErrors,
  } = useForm({});

  const getFormErrorMessage = (name) => {
    // console.log("regggggmi", errors);
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const documentDetailErrors = useSelector(
    (state) => state.documentDetails.errors
  );

  const [addVisible, setAddVisible] = useState(false);

  return (
    <Card
      className="p-col-12 p-md-12 main-card"
      header={
        <h3 className="p-col-12 p-md-12 text-center">
          <i className="pi pi-file" /> {t("documentDetails")}{" "}
        </h3>
      }
      footer={footer}
    >
      {documentDetailErrors && (
        <>
          <div className="p-field p-col-12 p-md-12 p-grid ">
            <ul className="requiredInfo">
              {documentDetailErrors &&
                Object.values(documentDetailErrors)
                  .filter((err) => err && err.message != null)
                  .map((err) => (
                    <>
                      <span style={{ color: "red", fontWeight: "normal" }}>
                        {err.message}
                      </span>
                      <br />
                    </>
                  ))}
            </ul>
          </div>
        </>
      )}
      <div className="p-grid p-fluid p-col-12 p-md-12" style={{ margin: 0 }}>
        {/* <h4 className="p-col-12 p-md-12">
          <p className="section-title">Document Upload</p>
        </h4> */}

        <Dialog
          style={{ width: 800 }}
          header="Document Form"
          visible={addVisible}
          onHide={() => {
            setAddVisible(false);
            resetDocumentForm();
          }}
        >
          <form onSubmit={handleSubmit(handleDocumentDetail)}>
            <div className="p-grid p-fluid compact-layout">
              <div className="p-field p-col-12 p-md-6 stick-right">
                <label className="p-col-12 p-md-6" htmlFor="documentType">
                  {t("documentType")}*
                </label>
                <div className="p-inputgroup">
                  <Controller
                    name="documentTypeId"
                    control={control}
                    rules={{ required: "Document Type is required." }}
                    render={({ field, fieldState }) => (
                      <Dropdown
                        value={documentTypeId}
                        filter showClear
                        disabled={loadingdt}
                        dropdownIcon={loadingdt ? 'pi pi-spinner pi-spin' : 'pi pi-chevron-down'}
                        onChange={(e) => {
                          field.onChange(e.value);
                          setDocumentTypeId(e.value);
                          if (e.value !== "O") {
                            setDocumentTypeOthers(null);
                          }
                        }}
                        options={documentTypeList.filter(
                          (p) =>
                            !NON_DOCUMENT_DETAIL_DOCUMENT.includes(p.code) &&
                            (formType === "I"
                              ? filterDocument(p, {
                                nationality,
                                isMinor,
                                isNrn,
                                documentForMinor,
                                locationType,
                              })
                              : filterCompanyDocument(p, { locationType }))
                          // && (p.isMultiple || !documentList.map(d => d.documentTypeId).includes(p.code))
                        )}
                        optionLabel={(data) =>
                          getTValue(i18n, data.descEng, data.descNep)
                        }
                        placeholder={t("selectDocumentType")}
                        optionValue={"code"}
                      />
                    )}
                  />
                </div>
                {getFormErrorMessage("documentTypeId")}
              </div>
              {documentTypeId && (
                documentType.information !== "NR") && (
                  <>
                    {documentTypeId === "O" ? (
                      <>
                        <div
                          className={
                            "p-field p-col-12 " +
                            (documentTypeId === "O"
                              ? "p-md-6 stick-left"
                              : "p-md-12")
                          }
                        >
                          <label
                            className="p-col-12 p-md-12"
                            htmlFor="documentTypeOthers"
                          >
                            {t("documentTypeOthers")}
                          </label>
                          <div className="p-inputgroup">
                            <Input
                              value={documentTypeOthers}
                              onChange={(e) => {
                                setDocumentTypeOthers(e.target.value);
                              }}
                              placeholder={t("documentTypeOthers")}
                            />
                          </div>
                        </div>
                      </>
                    ) : null}
                    {documentMetadata.docId && (
                      <div
                        className={
                          "p-field p-col-12 " +
                          (documentTypeId === "O"
                            ? "p-md-12 "
                            : "p-md-6 stick-left")
                        }
                      >
                        <label className="p-col-12 p-md-12" htmlFor="docId">
                          {documentMetadata.docId
                            ? getTValue(
                              i18n,
                              documentMetadata.docId.labelEng,
                              documentMetadata.docId.labelNep
                            )
                            : t("docId")}
                          *
                        </label>
                        <Controller
                          name="docId"
                          control={control}
                          rules={{
                            ...(documentMetadata.docId.mandatory
                              ? { required: "Document Id is required." }
                              : {}),
                            ...(documentMetadata.docId.regex
                              ? {
                                pattern: {
                                  value: new RegExp(
                                    documentMetadata.docId.regex
                                  ),
                                  message: "Provide valid document id",
                                },
                              }
                              : {}),
                          }}
                          render={({ field, fieldState }) => (
                            <div className="p-inputgroup">
                              {documentTypeId === 'NID' ?
                                <InputMask
                                  // id={field.name}
                                  value={docId}
                                  // keyFilter="alphanum"
                                  keyfilter={/^[a-zA-Z0-9]+$/}

                                  onChange={(e) => {
                                    field.onChange(e.target.value);
                                    setDocId(e.target.value);
                                  }}
                                  mask="9999999999"
                                  placeholder={documentMetadata.docId
                                    ? getTValue(
                                      i18n,
                                      documentMetadata.docId.labelEng,
                                      documentMetadata.docId.labelNep
                                    )
                                    : t("docId")}

                                  className={classNames({
                                    "p-invalid": fieldState.invalid,
                                  })}
                                /> :
                                <InputText
                                  id={field.name}
                                  {...field}
                                  value={docId}
                                  clearSpace
                                  keyfilter={
                                    documentTypeId === "BC" || documentTypeId === "CZ"
                                      ? /^[a-zA-Z0-9_/()-]+$/
                                      : /^[a-zA-Z0-9]+$/
                                  }
                                  placeholder={documentMetadata.docId
                                    ? getTValue(
                                      i18n,
                                      documentMetadata.docId.labelEng,
                                      documentMetadata.docId.labelNep
                                    )
                                    : t("docId")}

                                  // onChange={(e) => {
                                  //   field.onChange(e.target.value);
                                  //   setDocId(e.target.value);

                                  //   // Real-time validation logic
                                  //   const isValid = /^[a-zA-Z0-9]+$/.test(e.target.value);
                                  //   if (isValid) {
                                  //     // Clear any existing error message
                                  //     dispatch(setDocIdError({ message: "", section: documentTypeId }));
                                  //   } else {
                                  //     // Set error message for the specific section
                                  //     dispatch(setDocIdError({ message: "Provide a valid document ID", section: documentTypeId }));
                                  //   }
                                  // }}
                                  onChange={(e) => {
                                    const inputValue = e.target.value;
                                    if (/^[\x00-\x7F]*$/.test(inputValue)) {
                                      field.onChange(inputValue);
                                      setDocId(inputValue);
                                      // setError('');
                                    } else {
                                      field.onChange("");
                                      setDocId("");
                                    }
                                  }}
                                  className={classNames({
                                    // "p-invalid": fieldState.invalid || (docIdError?.section === documentTypeId && docIdError?.message),
                                    "p-invalid": fieldState.invalid || (docIdError?.section === documentTypeId && docIdError?.message),
                                  })}
                                />
                              }
                            </div>
                          )}
                        />
                        {/* {getFormErrorMessage("docId")} */}
                        {docIdError?.section === documentTypeId && docIdError?.message && (
                          <small className="p-error">{docIdError.message}</small>
                        )}
                      </div>
                    )}
                    {/* {documentMetadata.issuedDate && ( */}

                    {(documentMetadata.issuedDate && documentTypeId !== "NID") && (
                      <div
                        className={
                          "p-grid p-fluid compact-layout " +
                          (issuedDateError?.message
                            ? "p-md-8 "
                            : "p-md-8 ")
                        }
                      >
                        <Controller
                          name="issuedDate"
                          control={control}
                          rules={{
                            ...
                            (documentMetadata.issuedDate && documentMetadata.issuedDate.mandatory
                              // (documentMetadata.issuedDate.mandatory
                              ? { required: "Issued Date is required." }
                              : {}),
                          }}
                          render={({ field, fieldState }) => (
                            <AdBsDatePicker
                              css={(issuedDateError?.message ? "p-md-6" : "p-md-6")}
                              dateMetaData={documentMetadata.issuedDate}
                              label={documentMetadata.issuedDate.labelEng
                                ? getTValue(
                                  i18n,
                                  documentMetadata.issuedDate.labelEng,
                                  documentMetadata.issuedDate.labelNep)
                                : t("issuedDate")}
                              futureDate={documentMetadata.issuedDate.futureDate}
                              bsDate={issuedDateBs}
                              adDate={issuedDate}
                              getFormErrorMessageAd={getFormErrorMessage('issuedDate')}
                              getFormErrorMessageBs={getFormErrorMessage('issuedDateBs')}
                              onChange={(adDate, bsDate, extra) => {
                                field.onChange(
                                  adDate
                                );
                                setValue("issuedDate", adDate);
                                clearErrors("issuedDate");
                                setIssuedDate(adDate);
                                setIssuedDateBs(bsDate);
                                // console.log("warning", issuedDate);
                                // if (documentTypeId === "BC" && !issuedDate) {
                                //   dispatch(
                                //     setIssuedDateError({
                                //       message: " Valid Issued Date is required for BC",
                                //       section: "DOD",
                                //     })
                                //   );
                                // } else {
                                //   dispatch(
                                //     setIssuedDateError({ section: "DOD" })
                                //   );
                                // }
                                if (documentTypeId === "BC") {
                                  if (!issuedDate) {
                                    dispatch(
                                      setIssuedDateError({
                                        // message: "Valid Issued Date is required for BC",
                                        section: "DOD",
                                      })
                                    );
                                  } else {
                                    dispatch(setIssuedDateError({ section: "DOD" }));
                                  }
                                }
                              }}
                              // className={classNames({
                              //   "p-invalid": fieldState.invalid || (issuedDateError?.section === issuedDate && issuedDateError?.message),
                              // })}
                              className={classNames({
                                "p-invalid": fieldState.invalid || (issuedDateError?.section === documentTypeId && issuedDateError?.message),
                              })}
                            />
                          )}
                        />
                        {/* {getFormErrorMessage("issuedDate")} */}
                        {/* {issuedDateError?.section === documentTypeId && issuedDateError?.message && (
                          <small className="p-error" style={{ color: "red" }}>{issuedDateError.message}</small>
                        )} */}
                        {issuedDateError?.section === issuedDate && issuedDateError?.message && (
                          <small className="p-error" style={{ color: "red" }}>{issuedDateError.message}</small>
                        )}
                      </div>
                    )}


                    {(documentMetadata.issuedFrom && documentTypeId !== "NID") && (
                      //  {documentMetadata.issuedFrom && (
                      <div className="p-field p-col-12 p-md-4 stick-left">
                        <label className="p-col-12 p-md-12" htmlFor="issuedFrom">
                          {documentMetadata.issuedFrom
                            ? getTValue(
                              i18n,
                              documentMetadata.issuedFrom.labelEng,
                              documentMetadata.issuedFrom.labelNep
                            )
                            : t("issuingAuthorityPlace")}

                          {(documentMetadata.issuedFrom && documentMetadata.issuedFrom.mandatory) && "*"}
                          {/* {documentMetadata.issuedFrom.mandatory && "*"} */}
                        </label>
                        <Controller
                          name="issuedFrom"
                          control={control}
                          rules={{
                            ...(documentMetadata.issuedFrom && documentMetadata.issuedFrom.mandatory
                              // ...(documentMetadata.issuedFrom.mandatory
                              ? { required: "Issued From is required." }
                              : {}),
                            ...(documentMetadata.issuedFrom && documentMetadata.issuedFrom.regex
                              // ...(documentMetadata.issuedFrom.regex
                              ? {
                                pattern: {
                                  value: new RegExp(
                                    documentMetadata.issuedFrom.regex
                                  ),
                                  message: "Invalid issuing authority place",
                                },
                              }
                              : {}),
                          }}
                          render={({ field, fieldState }) => (
                            <div className="p-inputgroup">
                              {(documentTypeId !== "CZ" && documentTypeId !== "BC") ? (
                                <InputText
                                  id={field.name}
                                  {...field}
                                  value={issuedFrom}
                                  // keyFilter="alphanum"
                                  keyfilter={/^[a-zA-Z0-9]+$/}
                                  isName
                                  clearSpace
                                  placeholder={documentMetadata.issuedFrom
                                    ? getTValue(
                                      i18n,
                                      documentMetadata.issuedFrom.labelEng,
                                      documentMetadata.issuedFrom.labelNep
                                    )
                                    : t("issuingAuthorityPlace")}
                                  onChange={(e) => {
                                    field.onChange(e.target.value);
                                    setIssuedFrom(e.target.value);
                                  }}
                                  className={classNames({
                                    "p-invalid": fieldState.invalid,
                                  })}
                                />
                              ) : (
                                <Dropdown
                                  id={field.name}
                                  {...field}
                                  value={issuedFrom}
                                  filter showClear
                                  // className={classNames({
                                  //   "p-invalid": fieldState.invalid,
                                  // })}
                                  onChange={(e) => {
                                    field.onChange(e.target.value);
                                    setIssuedFrom(e.target.value);
                                    // setIssuedFromDesc(
                                    //   e.originalEvent.nativeEvent.target.ariaLabel
                                    // );
                                    setIssuedFromDesc(e.target.ariaLabel || "");
                                    // if (documentTypeId === "BC") {
                                    //   if (!issuedFrom) {
                                    //     dispatch(
                                    //       setIssuedFromError({
                                    //         // message: "Valid Issued From is required for BC",
                                    //         section: "DOD",
                                    //       })
                                    //     );
                                    //   } else {
                                    //     dispatch(setIssuedFromError({ section: "DOD" }));
                                    //   }
                                    // }
                                    // }}
                                    if (e.value) {
                                      dispatch(setIssuedFromError({ message: "", section: documentTypeId }));
                                    } else if (documentTypeId === "BC" || documentTypeId === "CZ") {
                                      dispatch(
                                        setIssuedFromError({
                                          message: "Issue From is required",
                                          section: documentTypeId,
                                        })
                                      );
                                    }
                                  }}
                                  // className={classNames({
                                  //   "p-invalid": fieldState.invalid || (issuedFromError?.section === issuedFrom && issuedFromError?.message),
                                  // })}
                                  className={classNames({
                                    "p-invalid": fieldState.invalid || (issuedFromError?.section === documentTypeId && issuedFromError?.message),
                                  })}
                                  options={districtList}
                                  optionLabel={(data) =>
                                    getTValue(i18n, data.descEng, data.descNep)
                                  }
                                  placeholder={documentMetadata.issuedFrom
                                    ? getTValue(
                                      i18n,
                                      documentMetadata.issuedFrom.labelEng,
                                      documentMetadata.issuedFrom.labelNep
                                    )
                                    : t("selectDistrict")}
                                  optionValue="code"
                                />
                              )}
                            </div>
                          )}
                        />
                        {/* {issuedFromError?.section === issuedFrom && issuedFromError?.message && (
                          <small className="p-error" style={{ color: "red" }}>{issuedFromError.message}</small>
                        )} */}
                        {getFormErrorMessage("issuedFrom")} {/* Add to show form validation errors */}
                        {issuedFromError?.section === documentTypeId && issuedFromError?.message && (
                          <small className="p-error" style={{ color: "red" }}>{issuedFromError.message}</small>
                        )}
                      </div>
                    )}
                    {/* //AMAN ADDED FOR FUTURE /}
                    {documentTypeId === "PP" && (
                      <div className="p-field p-col-12 p-md-6">
                        <label className="p-col-12 p-md-6" htmlFor="country">
                          {t("issuingCountry")}*
                        </label>
                        <div className="p-inputgroup">
                          <Controller
                            name="country"
                            control={control}
                            rules={{ required: "Country is required." }}
                            render={({ field, fieldState }) => {
                              return (
                                <Dropdown
                                  value={issuedFrom}
                                  className={classNames({
                                    "p-invalid": fieldState.invalid,
                                  })}
                                  filter
                                  showClear
                                  options={countryList}
                                  optionLabel={(data) =>
                                    getTValue(i18n, data.descEng, data.descNep)
                                  }
                                  onChange={(e) => {
                                    field.onChange(e.target.value);
                                    setIssuedFrom(e.target.value);
                                    setIssuedFromDesc(
                                      e.originalEvent.nativeEvent.target.ariaLabel
                                    );
                                  }}
                                  placeholder={documentMetadata.issuedFrom
                                    ? getTValue(
                                      i18n,
                                      documentMetadata.issuedFrom.labelEng,
                                      documentMetadata.issuedFrom.labelNep
                                    )
                                    : t("selectCountry")}
                                  optionValue="code"
                                />
                              );
                            }}
                          />
                        </div>
                        {getFormErrorMessage("country")}
                      </div>
                    )} */}
                  </>
                )}

              {documentTypeId &&
                (documentType.fileInfo !== "NR") && (
                  <div className="p-field p-col-12 p-md-12">
                    <label className="p-col-12 p-md-6">
                      {t("uploadFile")}*{' '} {fileError && <small className="p-error" style={{ fontSize: 14 }}>File is Required</small>}
                    </label>
                    <DocumentUpload
                      document={{ ...fileData, ...documentType }}
                      onUpload={(data) => {
                        setFileError(false);
                        setFileData({
                          ...fileData,
                          fileId: data.storageFileName,
                          fileName: data.originalName,
                        });
                      }}
                      onUploadBack={(data) => {
                        setFileError(false);
                        setFileData({
                          ...fileData,
                          backFileId: data.storageFileName,
                          backFileName: data.originalName,
                        });
                      }}
                    />

                  </div>
                )}
            </div>
            <div className="p-field p-col-12 p-md-12">
              <Button
                className="p-col-12 p-md-2 pull-right add-button"
                label={rowId ? "Update" : "Add"}
                type="submit"
                style={{ width: 100 }}
              />
              <Button
                className="p-col-12 p-md-2 pull-right add-button"
                label="Reset"
                type="reset"
                style={{ width: 100, marginRight: 10 }}
                onClick={() => resetDocumentForm()}
              />
            </div>
          </form>
        </Dialog>
        <span style={{ color: "red" }}>{documentDetailsError}</span>
        <div className="">
          <DataTable
            value={documentList.filter(
              (p) =>
                !NON_DOCUMENT_DETAIL_DOCUMENT.includes(p.documentTypeId) &&
                (formType === "I"
                  ? filterDocument(p, {
                    nationality,
                    isMinor,
                    isNrn,
                    documentForMinor,
                    locationType,
                  })
                  : filterCompanyDocument(p, { locationType }))
            )}
            style={{ minWidth: 700 }}
            header={
              <div
                className="table-header"
                style={{
                  display: "flex",
                  placeItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <p>{t("additionalDocuments")}</p>
                <Button
                  className="pull-right add-button"
                  label="Add"
                  icon="pi pi-plus"
                  style={{ width: "auto", padding: "0px 1rem" }}
                  onClick={(e) => {
                    setAddVisible(true);
                    resetDocumentForm();
                  }}
                ></Button>
              </div>
            }
            dataKey="document"
          >
            <Column
              field="documentTypeDesc"
              header={t("documentType")}
            ></Column>
            <Column field="docId" header={t("docId")}></Column>
            <Column
              body={(rowData, index) => {
                if (rowData.documentTypeId == "CZ" || rowData.documentTypeId == "BC")
                  return getDescription(districtList, rowData.issuedFrom);
                else return rowData.issuedFromDesc || rowData.issuedFrom;
              }}
              header={t("issuingAuthorityPlace")}
            ></Column>
            <Column
              // field="issuedDate"
              body={(rowData, index) =>
                rowData.issuedDate &&
                (typeof rowData.issuedDate === "string"
                  ? rowData.issuedDate
                  : new Date(rowData.issuedDate + 'EDT').toISOString().split("T")[0])
              }
              header={t("issuedDateAd")}
            ></Column>
            <Column field="issuedDateBs" header={t("issuedDateBs")}></Column>
            <Column
              style={{ width: 100 }}
              body={(rowData, index) => {
                return (
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <CustomImage
                      src={
                        rowData.fileId
                          ? ApiBaseURLProps.apiBaseURL +
                          "/file/" +
                          rowData.fileId
                          : "/no_file_icon.png"
                      }
                      alt="Image Text"
                      width={80}
                      height={80}
                      preview
                    />
                    {rowData.backFileId && (
                      <CustomImage
                        src={
                          rowData.backFileId
                            ? ApiBaseURLProps.apiBaseURL +
                            "/file/" +
                            rowData.backFileId
                            : "/no_file_icon.png"
                        }
                        alt="Image Text"
                        width={80}
                        height={80}
                        preview
                      />
                    )}
                  </div>
                );
              }}
              header={t("file")}
            ></Column>
            <Column
              style={{ width: 80 }}
              header={t("action")}
              body={(rowData, index) => {
                return (
                  <>
                    <i
                      className="pi pi-pencil"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        resetDocumentForm();
                        setAddVisible(true);
                        const document = documentList.filter(
                          (d) =>
                            (d.id || d.tempId) ===
                            (rowData.id || rowData.tempId)
                        );
                        setDocumentTypeId(rowData.documentTypeId);
                        if (rowData.documentTypeId == "O") {
                          setDocumentTypeOthers(rowData.documentTypeOthers);
                        }
                        setDocId(rowData.docId);
                        setIssuedDate(rowData.issuedDate);
                        setIssuedDateBs(rowData.issuedDateBs);
                        setIssuedFrom(rowData.issuedFrom);
                        setFileData({
                          fileId: rowData.fileId,
                          fileName: rowData.fileName,
                          backFileId: rowData.backFileId,
                          backFileName: rowData.backFileName,
                        });
                        setRowId(rowData.id || rowData.tempId);
                        reset({
                          ...rowData,
                        });
                      }}
                    />

                    {/* &nbsp;&nbsp;
                    <i
                      className="pi pi-trash"
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        displayConfirmModal(rowData.id || rowData.tempId)
                        // dispatch(
                        //   removeDocumentListData(rowData.id || rowData.tempId)
                        // );
                      }}
                    /> */}
                  </>
                );
              }}
            ></Column>
          </DataTable>
        </div>
        {/* {docStatus ? (
          <EditDocumentDetails
            rowData={rowData}
            editDocumentDetail={editDocumentDetail}
            documentTypeList={documentTypeList}
          />
        ) : (
          ""
        )} */}

        {/* {documentList
          .filter((p) =>
            formType === "I"
              ? filterDocument(p, {
                nationality,
                isMinor,
                isNrn,
                documentForMinor,
                locationType,
              })
              : filterCompanyDocument(p)
          )
          .map((p) => (
            <DocumentUpload
              document={p}
              onUpload={(data) => {
                dispatch(
                  setDocumentValue({
                    code: p.documentTypeId,
                    key: "fileId",
                    value: data.id,
                  })
                );
                dispatch(
                  setDocumentValue({
                    code: p.documentTypeId,
                    key: "fileName",
                    value: data.fileName,
                  })
                );
              }}
              onUploadBack={(data) => {
                dispatch(
                  setDocumentValue({
                    code: p.documentTypeId,
                    key: "backFileId",
                    value: data.id,
                  })
                );
                dispatch(
                  setDocumentValue({
                    code: p.documentTypeId,
                    key: "backFileName",
                    value: data.fileName,
                  })
                );
              }}
            />
          ))} */}
      </div>
      <span style={{ color: "red" }}>{documentDetailsError}</span>
      <DynamicFieldSection />
    </Card>
  );
}

export const DocumentUpload = ({
  document,
  onUpload,
  onUploadBack,
  noDisplayFileName,
}) => {
  // console.log(document, 'document');
  const { t, i18n } = useTranslation();
  return (
    <div className="p-field">
      <div className="p-grid">
        <div className="p-col-12 p-md-6">
          <div className="p-col-12 p-md-12" style={{ textAlign: 'center' }}>
            {document.isBothSided &&
              (<p>{t("frontSide")}</p>)
            }
          </div>
          <div className="p-mr-2">
            <FileUploadComponent thumbnail tip data={document} onUpload={onUpload} />
          </div>
        </div>
        <div className="p-col-12 p-md-6">
          {document.isBothSided && (
            <>
              <div className="p-col-12 p-md-12" style={{ textAlign: 'center' }}>
                {t("backSide")}
              </div>
              <div className="p-mr-2">
                <FileUploadComponent thumbnail tip data={{ ...document, fileId: document.backFileId, fileName: document.backFileName }} onUpload={onUploadBack} />
              </div>
            </>
          )}
        </div>
        {document.errorDesc && (
          <span style={{ color: "red" }}>{document.errorDesc}</span>
        )}
      </div>
    </div>
  );
};

export const filterCompanyDocument = (p, param) => {
  const { nationality, isMinor, documentForMinor, isNrn, locationType } = param;
  if (p.usedFor || p.type === "I") return false;

  switch (p.documentTypeId || p.code) {
    case "MP":
      return locationType === "I";
    default:
      return true;
  };
};


export const filterDocument = (p, param) => {
  const { nationality, isMinor, documentForMinor, isNrn, locationType } = param;
  if (p.usedFor || p.type === "C") return false;

  switch (p.documentTypeId || p.code) {
    case "CZ":
      return nationality === "NP" && (!isMinor || documentForMinor === "CZ");
    case "BC":
      return isMinor && documentForMinor === "BC";
    case "NR":
      return isNrn;
    case "PP":
      return nationality !== "NP";
    case "MP":
      return locationType === "I";
    case "NI":
      return nationality === "NP";
    case "NID":
      return isNrn != true;
    default:
      return true;
  }
};

export const mapDocument = (d) => ({
  ...d,
  op: d.id ? "U" : "I",
  documentTypeDesc: undefined,
  documentTypeDescNp: undefined,
  issuedFromDesc: undefined,
  type: undefined,
  issuedDate:
    d.issuedDate &&
    ("" + JSON.parse(JSON.stringify(d.issuedDate))).split("T")[0],
});

export default DocumentDetails;
